import { Component, TemplateRef ,OnInit, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  @Input() survey;

  public content: string;

  private modalRef: BsModalRef;
  private configModal: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false,
    class: 'gray modal-lg' 
  }

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
    const value = this.survey.content.rendered;
    const fromStr = value.indexOf("/>");
    this.content = `${value.substr(0, fromStr +3)}${value.substr(fromStr, 100)}...`
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.configModal);
  }
}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/surveys/card/card.component.ts